import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTreasuryUiContext } from "../providers/TreasuryUiContext";
import { getMmLatestTradesAction } from "../treasury.effects";
import {
  selectIsGetMmLatestTradesPending,
  selectMmLatestTrades,
} from "../treasury.selectors";
import CexLatestTradesFilters from "./CexLatestTradesFilters";
import CexLatestTradesList from "./CexLatestTradesList";

interface ICexLatestTradesProps {
  token: string;
}

export default function CexLatestTrades({ token }: ICexLatestTradesProps) {
  const { setIsTxWidgetsExpanded } = useTreasuryUiContext();
  const latestTrades = useSelector(selectMmLatestTrades(token));
  const isGetMmLatestTradesPending = useSelector(
    selectIsGetMmLatestTradesPending
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setIsTxWidgetsExpanded(true);
    dispatch(getMmLatestTradesAction(token));

    return () => {
      setIsTxWidgetsExpanded(false);
    };
  }, []);

  return (
    <>
      <CexLatestTradesFilters token={token} />
      <CexLatestTradesList
        trades={latestTrades}
        isLoading={isGetMmLatestTradesPending}
      />
    </>
  );
}
